import React from 'react'
import { TableRow, TableCell, Box, withStyles } from '@material-ui/core'
import { Icon } from '@iconify/react'
import checkmarkFill from '@iconify-icons/eva/checkmark-fill'
import styles from './styles'

const TableRowComponent = props => {
  const { row, classes } = props
  return (
    <TableRow>
      <TableCell className={classes.rootTableCell2}>{row.name}</TableCell>
      <TableCell className={classes.rootTableCell}>
        {row.basic === 'true' ? (
          <Box
            component={Icon}
            icon={checkmarkFill}
            className={classes.tableBox}
          />
        ) : (
          <div>{row.basic}</div>
        )}
      </TableCell>
      <TableCell className={classes.rootTableCell}>
        {row.pro === 'true' ? (
          <Box
            component={Icon}
            icon={checkmarkFill}
            className={classes.tableBox}
          />
        ) : (
          <div>{row.pro}</div>
        )}
      </TableCell>
      <TableCell className={classes.rootTableCell}>
        {row.elite === 'true' ? (
          <Box
            component={Icon}
            icon={checkmarkFill}
            className={classes.tableBox}
          />
        ) : (
          <div>{row.elite}</div>
        )}
      </TableCell>
    </TableRow>
  )
}

export default withStyles(styles)(TableRowComponent)
